// extracted by mini-css-extract-plugin
module.exports = {"taxonomiesWrapper":"TaxonomyCascader_taxonomiesWrapper__1L_nF","taxonomyItem":"TaxonomyCascader_taxonomyItem__22Urh","helpMessageIcon":"TaxonomyCascader_helpMessageIcon__3kK_8"};